/* eslint-disable  no-useless-escape */
import React, { useEffect } from "react";
import { toast } from "react-toastify";

const ActivateAccount = () => {
  useEffect(() => {
    // Function to parse URL parameters
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    document
      .getElementById("activateBtn")
      .addEventListener("click", function () {
        const user = getParameterByName("user_email"); // Extract user from URL parameter

        // Now use fetch to send a POST request
        fetch(
          `${process.env.REACT_APP_API_URL}?user_email=${user}&user_access_key=yl8s6qkhfzc`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ user: user }),
          }
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then(() => {
            window.location.href = process.env.REACT_APP_REDIRECT_URL;
          })
          .catch((err) =>
            toast.error(
              `${
                err.response?.data?.usr?.message ||
                err.response?.data?.message ||
                err.response?.message ||
                err.message
              }`
            )
          );
      });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        margin: 0,
        backgroundColor: "#f0f0f0", // Light grey background for better contrast
      }}
    >
      <button
        id="activateBtn"
        style={{
          padding: "10px 20px", // Large padding for bigger button
          fontSize: "1.25em", // Large text size
          backgroundColor: "#dd4b39", // Reddish background color
          color: "white", // White text
          border: "none", // No border
          cursor: "pointer", // Pointer cursor on hover
          width: "100%", // Full width
          maxWidth: "300px", // Maximum width
          display: "flex", // Flexbox for aligning text and icon
          alignItems: "center", // Center items vertically
          justifyContent: "center", // Center content horizontally
          borderRadius: "5px", // Rounded corners
          transition: "background-color 0.3s",
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "navy")} // Darker blue on hover for better interaction
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#dd4b39")} // Original color when mouse out
      >
        Activate Your Account
      </button>
    </div>
  );
};

export default ActivateAccount;
